import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { BsSearch } from "react-icons/bs";
import { MdModeEdit, MdDelete, MdRefresh } from "react-icons/md";
import Button from "Button/Button";
import colors from "styles/colors.module.scss";
import "./TableToolbar.scss";
import { DateTimePicker } from "@material-ui/pickers";
import { IoCalendarOutline } from "react-icons/io5";
import dayjs from "utils/dayjs";
import { TableTitle } from "constants/UserConstants";
import { InputAdornment } from "@material-ui/core";

function TableToolbar(props) {
  const {
    searchValue,
    onSearchTextChange,
    onAddButtonClick,
    onEditClick,
    onDeleteClick,
    isEditEnabled,
    isDeleteEnabled,
    title,
    onDateChage,
    startDate,
    endDate,
    onRefreshClick,
    onRecentOpty,
    filterButtonText
  } = props;
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    setSearchText(searchValue);
  }, [searchValue]);

  const onSearchInputChange = (e) => {
    const newSearchText = e.target.value;
    setSearchText(newSearchText);
    onSearchTextChange(newSearchText);
  };

  const noneEditsCls = !isEditEnabled && !isDeleteEnabled ? "none" : "";
  const isDateFilter = onDateChage ? "Filter" : "";
  const ShowDate = title == TableTitle.SalesOp ? "" : "none";
  return (
    <div className="table-toolbar">
      <div className="header-with-manage">
        {title && <h6 className="table-title">{title}</h6>}
        <div className="search-add-section">
          <div className={`search-input-with-icon ${isDateFilter}`}>
            <BsSearch className="search-icon" size="1em" />
            <input
              className="search-input"
              type="text"
              value={searchText}
              onChange={onSearchInputChange}
              placeholder="Search by any field"
            />
          </div>

          {/* If onDateChage() passes from the parent, the date filter will be displayed, and add button will remove */}
          {onDateChage ?
            <>
              <div className="date-filter-container">
                <label>Filter</label>
                <div className="child-Filter">
                  <DateTimePicker
                    variant="inline"
                    format="DD/MM/YYYY HH:mm a"
                    value={dayjs(startDate).format()}
                    maxDate={dayjs(endDate).format()}
                    showTodayButton
                    onChange={(e) => onDateChage({
                      startDate: e._d
                    })}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IoCalendarOutline className="calender-icon" size="1.1em" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <label>To</label>
                  <DateTimePicker
                    variant="inline"
                    format="DD/MM/YYYY HH:mm a"
                    value={dayjs(endDate).format()}
                    minDate={dayjs(startDate).format()}
                    maxDate={dayjs().format()}
                    openTo={"date"}
                    showTodayButton
                    onChange={(e) => onDateChage({
                      endDate: e._d
                    })}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IoCalendarOutline className="calender-icon" size="1.1em" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
              <Button
                className="get-recent-opty"
                onClick={onRecentOpty}
                label={filterButtonText}
              />
              <div className="refresh-icon-container" onClick={onRefreshClick}>
                <MdRefresh className="refresh-icon" />
              </div>
            </>
            :
            <Button
              className="add-user-btn"
              onClick={onAddButtonClick}
              label="Add"
            />
          }
        </div>
      </div>
      <div className={`edit-remove-section ${noneEditsCls}`}>
        <MdModeEdit
          className={`edit-btn icon ${!isEditEnabled ? `disabled` : ``}`}
          onClick={onEditClick}
          color={colors.lightBlue}
          size="1.5em"
          disabled={!isEditEnabled}
        />
        <MdDelete
          className={`delete-btn icon ${!isDeleteEnabled ? `disabled` : ``}`}
          onClick={onDeleteClick}
          color={colors.lightBlue}
          size="1.5em"
          disabled={!isDeleteEnabled}
        />
      </div>

    </div>
  );
}

TableToolbar.propTypes = {
  searchValue: PropTypes.string,
  onSearchTextChange: PropTypes.func.isRequired,
  onAddButtonClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  isEditEnabled: PropTypes.bool,
  isDeleteEnabled: PropTypes.bool,
  title: PropTypes.string,
  onDateChage: PropTypes.func,
  onRefreshClick: PropTypes.func,
};

TableToolbar.defaultProps = {
  searchValue: "",
  isEditEnabled: false,
  isDeleteEnabled: false,
  title: "",
};

export default TableToolbar;
